export enum Users {
    InviteUser = "Identity.Users.Invite User",
    UnlockUser = "Identity.Users.Unlock User",
}

export enum BrokerFileConfiguration {
    Access = "STODAR.Broker File Configuration.Access",
    AddBrokerFileType = "STODAR.Broker File Configuration.Add Broker File Type",
    Edit = "STODAR.Broker File Configuration.Edit",
    ViewImportProcesses = "STODAR.Broker File Configuration.View Import Processes",
}

export enum BrokerFileImportProcess {
    Access = "STODAR.Broker File Import Process.Access",
    Edit = "STODAR.Broker File Import Process.Edit",
    AddBrokerFileImportProcess = "STODAR.Broker File Import Process.Add Broker File Import Process",
}

export enum CatalogueRoles {
    Edit = "Catalogue.Generic Roles.Edit",
    View = "Catalogue.Generic Roles.View",
}

export enum ClientAccountMapping {
    Access = "STODAR.Client Account Mapping.Access",
    AddNew = "STODAR.Client Account Mapping.Add New",
}

export enum ColumnConfiguration {
    Access = "STODAR.Column Configuration.Access",
    Edit = "STODAR.Column Configuration.Edit",
    AddNew = "STODAR.Column Configuration.Add New",
}

export enum CheckQueryConfiguration {
    Access = "STODAR.Check Query Configuration.Access",
    Edit = "STODAR.Check Query Configuration.Edit",
}

export enum DataValidationConfiguration {
    Access = "STODAR.Data Validation Configuration.Access",
    Edit = "STODAR.Data Validation Configuration.Edit",
    AddNew = "STODAR.Data Validation Configuration.Add New",
}

export enum EventMapping {
    Access = "STODAR.Event Mapping.Access",
    Edit = "STODAR.Event Mapping.Edit",
    RunInterception = "STODAR.Event Mapping.Run Interception",
    Select = "STODAR.Event Mapping.Select",
}

export enum Events {
    Access = "STODAR.Events.Access",
    Edit = "STODAR.Events.Edit",
    Delete = "STODAR.Events.Delete",
    AddNew = "STODAR.Events.Add New",
}

export enum ExcludedAccounts {
    Access = "STODAR.Excluded Accounts.Access",
    AddNew = "STODAR.Excluded Accounts.Add New",
}

export enum FileConfigurations {
    Access = "STODAR.File Configurations.Access",
    AssignedBrokers = "STODAR.File Configurations.Assigned Brokers",
    ViewColumns = "STODAR.File Configurations.View Columns",
    Edit = "STODAR.File Configurations.Edit",
    AddNewVersion = "STODAR.File Configurations.Add New Version",
    AddNew = "STODAR.File Configurations.Add New",
}

export enum FreeTextEventMapping {
    Access = "STODAR.Free Text Event Mapping.Access",
    Edit = "STODAR.Free Text Event Mapping.Edit",
    AddNew = "STODAR.Free Text Event Mapping.Add New",
}

export enum GenerateTransactions {
    Access = "STODAR.Generate Transactions.Access",
    AddNew = "STODAR.Generate Transactions.Add New",
}

export enum GenericMappings {
    Access = "STODAR.Generic Mappings.Access",
    Edit = "STODAR.Generic Mappings.Edit",
    AddNew = "STODAR.Generic Mappings.Add New",
}

export enum Holdings {
    Access = "STODAR.Holdings.Access",
}

export enum Home {
    Access = "STODAR.Home.Access",
    WAC = "STODAR.Home.WAC",
    Intercept = "STODAR.Home.Intercept",
    Normalise = "STODAR.Home.Normalise",
    ViewChart = "STODAR.Home.View Chart",
    FilesProcessing = "STODAR.Home.Processing Files",
    Remove = "STODAR.Home.Remove Files",
}

export enum InstrumentMapping { 
    Access = "STODAR.Instrument Mapping.Access",
    Select = "STODAR.Instrument Mapping.Select",
    RunInterception = "STODAR.Instrument Mapping.Run Interception",
}

export enum Instruments {
    Access = "STODAR.Instruments.Access",
    Edit = "STODAR.Instruments.Edit",
    AddNew = "STODAR.Instruments.Add New",
}

export enum InstrumentTypes {
    Access = "STODAR.Instrument Types.Access",
    Edit = "STODAR.Instrument Types.Edit",
    AddNew = "STODAR.Instrument Types.Add New",
}

export enum MissingAccounts {
    Access = "STODAR.Missing Accounts.Access",
    MapAccount = "STODAR.Missing Accounts.Map Account",
    ExcludeAccount = "STODAR.Missing Accounts.Exclude Account",
}

export enum OrganisationConfigurationsRoles {
    Edit = "Catalogue.Organisation Configurations.Edit",
    View = "Catalogue.Organisation Configurations.View",
}

export enum SecurityTransfers {
    Access = "STODAR.Security Transfers.Access",
    Delete = "STODAR.Security Transfers.Delete",
    AddNew = "STODAR.Security Transfers.Add New",
    Edit = "STODAR.Security Transfers.Edit",
}

export enum ServiceProviders {
    Access = "STODAR.Service Providers.Access",
    Edit = "STODAR.Service Providers.Edit",
    ViewFiles = "STODAR.Service Providers.View Files",
    AddNew = "STODAR.Service Providers.Add New"
}

export enum TradeOrders{
    Access = "STODAR.Trade Orders.Access",
    Release = "STODAR.Trade Orders.Release",
    Confirm = "STODAR.Trade Orders.Confirm",
    Reject = "STODAR.Trade Orders.Reject",
    Reinstate = "STODAR.Trade Orders.Reinstate",
    Download = "STODAR.Trade Orders.Download",
    View = "STODAR.Trade Orders.View",
}

export enum TradeOrderVM {
    Access = "STODAR.Trade Orders.Access",
    Edit = "STODAR.Trade Orders.Edit",
}

export enum TransactionInterception {
    Access = "STODAR.Transaction Interception.Access",
}

export enum Transactions {
    Access = "STODAR.Transactions.Access",
}

export enum AuthorisableRequests {
    Access = "STODAR.Authorisable Requests.Access",
    Edit = "STODAR.Authorisable Requests.Edit"
}

